const defaultState = {
  open: false,
  page: 'AvailableFlows',
  title: 'Connect your data',
  breadcrumbs: [],
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type } = action;

  switch (type) {
    case 'OPEN_WIDGET':
      newState.open = true;
      return newState;

    case 'CLOSE_WIDGET':
      newState = defaultState;
      return newState;

    case 'CHANGE_PAGE':
      newState = { ...newState, ...payload };
      return newState;
  }

  return state;
};
